import React from 'react';
import { Notification } from './Notification';
import { NotificationItem } from '../hooks/useNotification';

export interface NotificationContainerProps {
    notifications: NotificationItem[];
    theme: any;
    onRemove: (id: string) => void;
}

export const NotificationContainer: React.FC<NotificationContainerProps> = ({
    notifications,
    theme,
    onRemove
}) => {
    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            maxHeight: 'calc(100vh - 40px)',
            overflow: 'hidden'
        }}>
            {notifications.map((notification, index) => (
                <div
                    key={notification.id}
                    style={{
                        transform: `translateX(${index * 20}px)`,
                        transition: 'transform 0.3s ease-in-out'
                    }}
                >
                    <Notification
                        type={notification.type}
                        title={notification.title}
                        message={notification.message}
                        duration={notification.duration}
                        theme={theme}
                        onClose={() => onRemove(notification.id)}
                    />
                </div>
            ))}
        </div>
    );
}; 